"use client";

import { useModal } from "@/contexts/ModalContext";
import type { ButtonHTMLAttributes, ReactNode } from "react";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
};

/** Small client island — opens the app download modal. */
export function OpenDownloadModalButton({
  children,
  type = "button",
  ...rest
}: Props) {
  const { openModal } = useModal();
  return (
    <button type={type} onClick={openModal} {...rest}>
      {children}
    </button>
  );
}
